import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import Button from '../../../../../ui/canon/Button';
import { SendIcon, StarIcon } from 'lucide-react';

const RatingWidget = ({ onAnswer, disabled, max = 5, initialValue = 0 }) => {
  const intl = useIntl();
  const [rating, setRating] = useState(initialValue || 0);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    setRating(initialValue || 0);
    setIsSubmitting(false);
  }, [initialValue]);

  const handleSubmit = () => {
    if (rating > 0 && !isSubmitting) {
      setIsSubmitting(true);
      onAnswer({ value: rating });
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex gap-2 justify-center">
        {[...Array(max)].map((_, i) => (
          <button
            key={i}
            type="button"
            disabled={disabled || isSubmitting}
            onClick={() => setRating(i + 1)}
            className="focus:outline-none transition-transform hover:scale-110"
          >
            <StarIcon
              className={`h-8 w-8 ${
                i < rating ? 'text-yellow-400 fill-current' : 'text-gray-300'
              }`}
            />
          </button>
        ))}
      </div>
      <Button
        onClick={handleSubmit}
        disabled={rating === 0 || disabled || isSubmitting}
        className="w-full"
      >
        <SendIcon className="h-4 w-4 mr-2" />
        {intl.formatMessage({ id: 'succession.plans.widget_submit_answer' })}
      </Button>
    </div>
  );
};

export default RatingWidget;
